import React from 'react';
import { IconRemove } from 'src/content/icons';
import { strings } from 'src/localization/index';
import { Diagnoses } from '../WriteYourOwn';
import css from './AddedIssues.module.scss';

interface IProps {
    // The list of diagnosed and custom issues
    IssueList: Diagnoses[]
    // Removes an issue from the list
    removeIssue: (id: string, e: any) => void
    theme: string
}

const AddedIssues = (props: IProps) => {
    const issues = props.IssueList.map((issue, index) => (
        <div key={index} className={css.issue}>
            <p className={css.issueText}>{issue.diagnosis}</p>
            <IconRemove id={'deleteBtn' + index} onClick={(e: any) => props.removeIssue(issue.id, e)} className={css.icon}/>
        </div>
    ));

    return (
        <div id='addedIssues'>
            <h2 className={props.theme === 'mazda' && css.headerMazda}>{strings.AddedIssue}</h2>
            {issues}
        </div>
    );
};

export default AddedIssues;